import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {Step} from '../../../models/convo';
import {StepId} from '../../../models/uuid';
import {Subject} from 'rxjs';
import {Alias, Provider} from '../../../models/llm/llm';
import {ConvoService} from 'src/moti/services/convo.service';
import {AliasLabelComponent} from '../../alias-label/alias-label.component';
import {ButtonExtendedComponent} from '../../button-extended/button-extended.component';
import {SpinnerComponent} from 'src/lib/components/spinner/spinner.component';
import {ButtonExtendedGroupComponent} from '../../button-extended-group/button-extended-group.component';
import {MotiOptionGroup} from 'src/moti/models/moti-option';


@Component({
  selector: 'moti-convo-bubble-options',
  templateUrl: './convo-bubble-options.component.html',
  styleUrl: './convo-bubble-options.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AliasLabelComponent,
    ButtonExtendedComponent,
    SpinnerComponent,
    ButtonExtendedGroupComponent,
  ],
})
export class ConvoBubbleOptionsComponent {
  @Input() step: Step;
  @Input() enableEmailButton: boolean;
  @Input() enableUseButton: boolean;
  @Input() enableAddButton: boolean;
  @Input() enableRegenButton: boolean;
  @Input() enableDeleteButton: boolean;
  @Input() asColumn: boolean;
  @Input() showModel: boolean;
  @Input() showModelMenu: boolean;

  // This component will set this to true and then the parent will set
  // it to false as soon as the new step has started appearing in the
  // UI
  @Input() addingStep: boolean;
  // The parent will set this to true while the step is still loading
  // (streaming) from the API
  @Input() loadingStep: boolean;
  // The parent will set this to true while the user's request to
  // use this step as primary is pending
  @Input() selectingStep: boolean;
  // The parent will set this to true while the user's request to
  // delete this step is pending
  @Input() deletingStep: boolean;

  @Output() clickedAdd$: EventEmitter<Alias> = new EventEmitter<Alias>();
  @Output() clickedUse$: EventEmitter<StepId> = new EventEmitter<StepId>();
  @Output() clickedDelete$: EventEmitter<StepId> = new EventEmitter<StepId>();

  clipboardSuccess$: Subject<boolean> = new Subject<boolean>();


  constructor(
    protected convoSvc: ConvoService,
  ) {
  }


  // TODO: We will need this later, not at launch
  // onClickCopy() {
  //   navigator.clipboard.writeText(this.step.text).then(() => {
  //     this.clipboardSuccess$.next(true);
  //   }).catch(err => {
  //     console.error(err);
  //   });
  // }

  onClickUse() {
    this.clickedUse$.emit(this.step.id);
  }


  onClickRegen() {
    this.convoSvc.sendStepRegen(this.step.id, this.step.convoId);
    this.loadingStep = true;
  }


  onClickDelete() {
    this.clickedDelete$.emit(this.step.id);
  }


  protected modelOptions: MotiOptionGroup;


  protected readonly Provider = Provider;


  protected popoverInfoDelay: number = 300;

  protected useInfoHtml: string = `<strong>Use</strong> <i class="fa-solid fa-check"></i><br><br>Make this the accepted AI response on which future messages in this convo are based.`;
  protected addInfoHtml: string = `<strong>Add</strong> <i class="fa-solid fa-plus"></i><br><br>Produce another response from the same or a different model to compare side-by-side.`;
  protected regenInfoHtml: string = `<strong>Regen</strong> <i class="fa-solid fa-rotate-right fa-rotate-180"></i><br><br>Discard this response and generate a new one to replace it.`;
  protected deleteInfoHtml: string = `<strong>Delete</strong> <i class="fa-solid fa-trash"></i><br><br>Permanently delete this message.`;
}
